import { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaExternalLinkAlt } from "react-icons/fa";
import { MdCheck, MdClose } from "react-icons/md";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { UserType } from "../../../../../context/userContext/props";
import { ButtonFavorite } from "../../../../components/button-favorite";
import { ButtonInterest } from "../../../../components/button-interest";
import { CopyComponent } from "../../../../components/copy-button";
import { FileViewer } from "../../../../components/fileviewer";
import { IObject } from "../../../../models/IObject";
import { removeFavorite } from "../../../../services/favorites.service";
import { detailMedia } from "../../../../services/media.service";
import {
	CardDescriptionForMedia,
	CardDescriptionFull,
	LimitCharacterDiv,
	ObjectValuesTitle,
} from "./styles";
import { CardTitle } from "../../styled";
import { colors } from "../../../../../theme/theme";
import { ButtonGoBack } from "../../components/button-go-back";

export const MediaDetails = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const { id } = useParams<{ id: string }>();

	const [loading, setLoading] = useState(true);
	const [material, setMaterial] = useState<IObject>();
	const [user, setUser] = useState<UserType>();

	useEffect(() => {
		let usuario = localStorage.getItem("user-store");
		if (usuario) {
			let auth = JSON.parse(usuario);
			setUser(auth);
		}
		if (id) {
			detailMedia(id).then((resp) => {
				setMaterial(resp);
				setLoading(false);
			});
		}
	}, [id]);

	if (loading) {
		return (
			<div className="loading-container mt-5">
				<Spinner animation="border" variant="primary" />
			</div>
		);
	}

	const redirectDiscipline = () => {
		history.push(`/disciplines/${material?.discipline_id}`);
	};

	const redirectItem = () => {
		history.push(`/unity/${material?.item_id}`);
	};

	const redirectTheme = () => {
		history.push(`/themes/${material?.item_id}`);
	};

	const handleRemoveFavorite = (_id: number) => {
		removeFavorite(_id)
			.then(() => {
				toast.success("Material removido com sucesso!", {
					position: "bottom-center",
				});
			})
			.catch((err: any) => {
				toast.error("Ocorreu um erro ao remover este material.");
			});
	};

	return (
		<Container fluid className="h-100">
			<Row>
				<Row>
					<CardTitle color={colors.mainColors.capri}>
						<Row>
							<Col
								xs={9}
								lg={11}
								className="d-flex align-items-center"
							>
								<ButtonGoBack />
								{material?.category.title}
							</Col>
							<Col xs={3} lg={1}>
								<Row>
									<Col xs={2} lg={1} className="mr-3">
										{!!user && user.token && (
											<ButtonFavorite
												material={material}
												showText={false}
												isMaterialView={false}
												removeFavorite={() =>
													handleRemoveFavorite(
														material?.favorite_id as number
													)
												}
												variant="white"
											/>
										)}
									</Col>
									{!!user &&
										(user.is_signature ||
											user.is_superuser) && (
											<Col xs={4} lg={1}>
												{material?.deadline === 1 ? (
													<CopyComponent
														ownsMaterial={
															material?.owns_discipline ||
															false
														}
														color="white"
														onCopy={() => {}}
														copyText={`${id}`}
													/>
												) : (
													<ButtonInterest
														color="#ffff"
														interesting={
															material?.interesting
														}
														id={material?.id || 0}
													/>
												)}
											</Col>
										)}
								</Row>
							</Col>
						</Row>
					</CardTitle>
				</Row>
				<Row>
					<Col
						md={12}
						lg={8}
						style={{ paddingLeft: 0 }}
						className="mb-3"
					>
						<CardDescriptionFull
							className="mt-3 h-100 w-100"
							style={{ padding: 0 }}
						>
							<Row className="h-100">
								<div
									className="h-100"
									style={{
										minHeight: "calc(100vh - 220px)",
										padding: 32,
									}}
								>
									<FileViewer
										key={1}
										fileType={material?.format}
										filePath={material?.public_file}
										preview_index={
											material?.preview_file_index
										}
										preview_url={material?.preview_url}
									></FileViewer>
								</div>
							</Row>
						</CardDescriptionFull>
					</Col>
					<Col md={12} lg={4} className="mt-3 ">
						<Row className="mb-3">
							<CardDescriptionForMedia>
								<LimitCharacterDiv>
									<b>{translation("material.code")}: </b>{" "}
									{material?.code ||
										translation("userAccount.uninformed")}
								</LimitCharacterDiv>
								{material?.discipline ? (
									<LimitCharacterDiv>
										<b>
											{translation("material.discipline")}
											:{" "}
										</b>{" "}
										<div
											style={{
												display: "inline-block",
												cursor: "pointer",
												color: "#6473FF",
											}}
											onClick={redirectDiscipline}
										>
											{material?.discipline}{" "}
											<FaExternalLinkAlt
												style={{
													fontSize: "12px",
													marginLeft: "8px",
												}}
											></FaExternalLinkAlt>
										</div>
									</LimitCharacterDiv>
								) : (
									<LimitCharacterDiv>
										<b>
											{translation("material.discipline")}
											:{" "}
										</b>{" "}
										{translation("userAccount.uninformed")}{" "}
									</LimitCharacterDiv>
								)}

								{material?.item ? (
									<>
										{!material?.is_theme && (
											<LimitCharacterDiv>
												<b>
													{translation(
														"manager.type.unity"
													)}
													:{" "}
												</b>{" "}
												<div
													style={{
														display: "inline-block",
														cursor: "pointer",
														color: "#6473FF",
													}}
													onClick={redirectItem}
												>
													{material.item}{" "}
													<FaExternalLinkAlt
														style={{
															fontSize: "12px",
															marginLeft: "8px",
														}}
													></FaExternalLinkAlt>
												</div>
											</LimitCharacterDiv>
										)}

										{material?.is_theme && (
											<LimitCharacterDiv>
												<b>
													{translation(
														"manager.type.theme"
													)}
													:{" "}
												</b>{" "}
												<div
													style={{
														display: "inline-block",
														cursor: "pointer",
														color: "#6473FF",
													}}
													onClick={redirectTheme}
												>
													{material.item}{" "}
													<FaExternalLinkAlt
														style={{
															fontSize: "12px",
															marginLeft: "8px",
														}}
													></FaExternalLinkAlt>
												</div>
											</LimitCharacterDiv>
										)}
									</>
								) : (
									<LimitCharacterDiv>
										<b>
											{translation("manager.type.unity")}:{" "}
										</b>{" "}
										{translation("userAccount.uninformed")}
									</LimitCharacterDiv>
								)}
								<Col>
									<LimitCharacterDiv>
										<b>
											{translation(
												"components.card-news.knowledge"
											)}
											:{" "}
										</b>{" "}
										{!!material?.knowledge_area
											? material.knowledge_area.length > 1
												? material.knowledge_area[0]
														?.description + " +"
												: material.knowledge_area[0]
														?.description
											: translation(
													"userAccount.uninformed"
											  )}
									</LimitCharacterDiv>
								</Col>
								<Col>
									<LimitCharacterDiv>
										<b>
											{translation(
												"components.card-news.Deadline"
											)}
											:{" "}
										</b>{" "}
										{material?.deadline
											? material.deadline > 1
												? "20 Dias"
												: "Pronta Entrega"
											: translation(
													"userAccount.uninformed"
											  )}
									</LimitCharacterDiv>
								</Col>
							</CardDescriptionForMedia>
						</Row>
						<Row>
							<CardDescriptionFull>
								<ObjectValuesTitle>
									{material?.category.category_icon ? (
										<em
											className={`material-icons-${material.category.category_icon}`}
										>
											{
												material.category.category_icon.split(
													" "
												)[1]
											}
										</em>
									) : (
										<em className="material-icons-outlined sticky_note_2">
											sticky_note_2
										</em>
									)}
									<span className="text-darker-grey">
										Especificações
									</span>
								</ObjectValuesTitle>
								<div className="text-darker-grey">
									{!!material?.delivery_values?.length &&
										material.delivery_values.map(
											(arrayValues, index) => {
												return (
													<LimitCharacterDiv
														key={index}
														className="mt-2"
													>
														<b>
															{arrayValues.title}:
														</b>{" "}
														{arrayValues.value ===
														"True" ? (
															<MdCheck
																color="#14CC70"
																size={17}
															/>
														) : arrayValues.value ===
														  "False" ? (
															<MdClose
																color="#FF4949"
																size={17}
															/>
														) : (
															arrayValues.value
														)}
													</LimitCharacterDiv>
												);
											}
										)}
									{!material?.delivery_values?.length && (
										<p>
											{translation(
												"userAccount.uninformed"
											)}
										</p>
									)}
								</div>
							</CardDescriptionFull>
						</Row>
					</Col>
				</Row>
			</Row>
		</Container>
	);
};
